import {
  HTTP_DEPARTMENT_FETCHING,
  HTTP_DEPARTMENT_SUCCESS,
  HTTP_DEPARTMENT_FAILED,
  server,
} from "./../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateDepartmentToFetching = () => ({
  type: HTTP_DEPARTMENT_FETCHING,
});

export const setStateDepartmentToSuccess = (payload) => ({
  type: HTTP_DEPARTMENT_SUCCESS,
  payload,
});

export const setStateDepartmentToFailed = (payload) => ({
  type: HTTP_DEPARTMENT_FAILED,
});

export const getDepts = (countryid, companyid, secid, brandid) => {
  return async (dispatch) => {
    dispatch(setStateDepartmentToFetching());

    try {
      const result = await httpClient.get(
        `${server.DEPART_URL}/${countryid}/${companyid}/${secid}/${brandid}`
      );
      dispatch(setStateDepartmentToSuccess(result.data));
    } catch (error) {
      dispatch(setStateDepartmentToFailed());
    }
  };
};
